<template>
  <div>
    <el-card>
      <el-button
        size="mini"
        style="width: 90px; margin-left: 50px"
        type="primary"
        @click="addOpen"
        >添加奖项</el-button
      >
    </el-card>
    <el-card style="margin-top: 20px">
      <el-table
        :data="list"
        :header-cell-style="getRowClass"
        border
        ref="multipleTable"
        style="width: 100%; flex: auto"
        tooltip-effect="light"
      >
        <el-table-column
          prop="name"
          label="奖项名称"
          align="center"
        ></el-table-column>
        <el-table-column prop="isShow" label="展示抽奖结果" align="center"
          ><template slot-scope="{ row }">
            <el-button v-if="row.isShow == 1" type="success" size="mini"
              >是</el-button
            >
            <el-button v-if="row.isShow == 0" type="info" size="mini"
              >否</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="maxTimes"
          label="奖品数量"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="winTimes"
          label="已中奖数量"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="rank"
          label="排名"
          align="center"
        ></el-table-column>
        <el-table-column
          align="center"
          class-name="small-padding fixed-width"
          label="操作"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <div class="done">
              <el-button
                size="mini"
                style="width: 90px; margin: 0 0 10px 10px"
                type="primary"
                @click="deleteDetail(row)"
                >删除</el-button
              >
              <el-button
                size="mini"
                style="width: 90px; margin: 0 0 10px 10px"
                type="primary"
                @click="changeDetail(row)"
                >修改</el-button
              >
              <el-button
                size="mini"
                style="width: 90px; margin: 0 0 10px 10px"
                type="primary"
                @click="decided(row)"
                >内定</el-button
              >
              <el-button
                size="mini"
                style="width: 90px; margin: 0 0 10px 10px"
                type="primary"
                @click="lookList(row)"
                >中奖名单</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <a-modal
      v-model="visibile"
      title="添加奖项"
      :footer="null"
      class="broadcast"
      @cancel="closeModel"
    >
      <el-form
        :model="toAdDas"
        label-position="right"
        ref="ruleForm"
        label-width="100px"
        style="width: 90%; margin: 20px auto"
      >
        <el-row>
          <el-col>
            <el-form-item label="奖项名称" prop="name">
              <el-input
                placeholder="请输入内容"
                v-model="toAdDas.name"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="排名" prop="rank">
              <el-input-number
                v-model="toAdDas.rank"
                :min="0"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="奖品数量" prop="maxTimes">
              <el-input-number
                v-model="toAdDas.maxTimes"
                :min="0"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="已中奖数量" prop="winTimes">
              <el-input-number
                v-model="toAdDas.winTimes"
                :min="0"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="展示抽奖结果" prop="isShow">
              <el-checkbox v-model="toAdDas.isShow"></el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-button type="primary" size="small" @click="addDeatil">确定</el-button>
    </a-modal>
    <!-- 删除弹出框 -->
    <a-modal
      :visible="delOpen"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <p>确定要删除吗？</p>
    </a-modal>
    <!-- 修改 -->
    <a-modal
      :visible="changeOpen"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk2"
      @cancel="handleCancel2"
      style="width: 700px"
    >
      <el-form label-width="100px">
        <el-form-item label="奖项名称">
          <el-col :span="20">
            <el-input
              v-model="changeList.name"
              placeholder="请输入内容"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="排名">
          <el-col>
            <el-input-number
              v-model="changeList.rank"
              :min="0"
            ></el-input-number>
          </el-col>
        </el-form-item>
        <el-form-item label="奖品数量">
          <el-col>
            <el-input-number
              v-model="changeList.maxTimes"
              :min="0"
            ></el-input-number>
          </el-col>
        </el-form-item>
        <el-form-item label="已中奖数量">
          <el-col>
            <el-input-number
              v-model="changeList.winTimes"
              :min="0"
            ></el-input-number>
          </el-col>
        </el-form-item>
        <el-form-item label="展示抽奖结果" prop="isShow">
          <el-col>
            <el-checkbox
              v-model="changeList.isShow"
            ></el-checkbox>
          </el-col>
        </el-form-item>
      </el-form>
    </a-modal>
    <!-- 查看内定 -->
    <el-dialog title="内定人员" :visible.sync="dialogTableVisible">
      <el-table
        :data="lookLists"
        :header-cell-style="getRowClass"
        border
        ref="multipleTable"
        style="width: 100%; flex: auto"
        tooltip-effect="light"
      >
        <el-table-column
          prop="nickname"
          label="nickname"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="phone"
          label="phone"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="openid"
          label="openid"
          align="center"
        ></el-table-column>
        <el-table-column prop="headimgurl" label="headimgurl" align="center">
          <template slot-scope="{ row }">
            <viewer>
              <img
                :src="row.headimgurl"
                alt=""
                style="width: auto; height: 50px"
              />
            </viewer>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <a-drawer
      title="用户列表"
      :width="1300"
      :visible="changeVisibile"
      :body-style="{ paddingBottom: '80px' }"
      @close="onClose"
    >
      <NeiDing :NeiDingData="NeiDingData" />
    </a-drawer>
  </div>
</template>
<script>
import { baseURL } from "../../api/config";
import NeiDing from "./wxList";
export default {
  props: ["Detaildata"],
  components: {
    NeiDing,
  },
  data() {
    return {
      visibile: false,
      delOpen: false,
      changeOpen: false,
      lookOpen: false,
      disabled: false,
      changeVisibile: false,
      pagesize: 10, //每页的个数
      currentPage: 1, //初始页
      totalCount: 0, //分页数量展示
      addList: {
        content: "",
        valuesImg: "",
        mediaType: "",
        video: "",
        id: "",
      },
      show: true,
      imgList: [],
      changeImgList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      list: [],
      selectVal: "",
      detailId: "",
      changeList: [],
      lookLists: [],
      NeiDingData: [],
      //添加的参数：
      toAdDas: {
        name: "", //奖项名称
        maxTimes: "", //奖品数量
        winTimes: "", //已中奖数量,
        rank: "", //排名
        isShow: "", //展示抽奖结果
      },
      dialogTableVisible: false,
    };
  },
  methods: {
    //将中国标准时间转换为年月日格式  ----开始
    formatTen(num) {
      return num > 9 ? num + "" : "0" + num;
    },
    formatDate(date) {
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hour = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      return (
        year +
        "-" +
        this.formatTen(month) +
        "-" +
        this.formatTen(day) +
        " " +
        this.formatTen(hour) +
        ":" +
        this.formatTen(minute) +
        ":" +
        this.formatTen(second)
      );
    },
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
      } else {
        return "";
      }
    },
    addOpen() {
      this.visibile = true;
    },
    onClose() {
      this.changeVisibile = false;
      this.getList();
    },
    changeSelect(val) {
      this.selectVal = val;
      if (val == 2) {
        this.show = false;
      } else {
        this.show = true;
      }
    },
    deleteDetail(row) {
      this.delOpen = true;
      this.detailId = row.id;
    },
    changeDetail(row) {
      this.changeList = row;
      if (this.changeList.isShow == "1") {
        this.changeList.isShow = true;
      } else {
        this.changeList.isShow = false;
      }
      this.changeOpen = true;
    },
    decided(row) {
      this.changeVisibile = true;
      this.NeiDingData = row;
    },
    lookList(row) {
      this.lookLists = row.winnerList;
      this.dialogTableVisible = true;
    },
    handleOk2() {
      this.postAxios("/raffle/option/edit", {
        id: this.changeList.id,
        name: this.changeList.name,
        maxTimes: this.changeList.maxTimes,
        winTimes: this.changeList.winTimes,
        rank: this.changeList.rank,
        isShow: Number(this.changeList.isShow),
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.changeOpen = false;
          this.getList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleCancel2() {
      this.changeOpen = false;
    },
    closeModel() {
      this.addList = {};
      this.imgList = [];
    },
    //不删除：
    handleCancel() {
      this.delOpen = false;
    },
    handleOk() {
      this.getAxios("/raffle/delete/option", {
        optionId: this.detailId,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.getList();
          this.delOpen = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    addDeatil() {
      this.postAxios("/raffle/add/option", {
        name: this.toAdDas.name,
        maxTimes: this.toAdDas.maxTimes,
        winTimes: this.toAdDas.winTimes,
        rank: this.toAdDas.rank,
        raffleId: this.Detaildata.id,
        isShow: Number(this.toAdDas.isShow),
      }).then((res) => {
        if (res.success == true) {
          this.visibile = false;
          this.toAdDas = {};
          this.$nextTick(() => {
            this.toAdDas.maxTimes = 0;
            this.toAdDas.winTimes = 0;
            this.toAdDas.rank = 0;
            this.toAdDas.isShow = 0;
          });

          this.getList();
          //   this.$router.push({ path: "/lucky" });
          this.$message.success(res.message);
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    getList() {
      this.getAxios("/raffle/detail", {
        raffleId: this.Detaildata.id,
      }).then((res) => {
        this.list = res.entity.optionList;
      });
    },
    //分页
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //分页：
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.getList();
    },
    //分页
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
  mounted() {
    this.getList();
  },
  watch: {
    Detaildata(newVal, oldVal) {
      this.Detaildata.id = newVal.id;
      this.getList();
    },
  },
};
</script>
<style scoped lang="less">
/deep/.avatar-uploader1 {
  .el-upload {
    width: 200px;
    height: auto;
    display: inline-block;
    text-align: center;
    cursor: pointer;
    outline: 0;
    border: 2px dashed #eee;
    img {
      width: 100%;
      height: auto;
    }
  }
}
// /deep/ .el-upload-list__item-status-label {
//   display: none !important;
// }
// /deep/ .el-upload-list__item-actions {
//   display: none;
// }
/deep/ .ant-modal-content {
  width: 700px;
}
video {
  width: 150px;
  height: 100px;
}
</style>